package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.AccountRepository
import com.clany.backoffice.model.AccountResponse
import io.ktor.client.request.parameter
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.HttpMethod

import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class AccountRepositoryImpl(
    private val networkClient: NetworkClient
) : AccountRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getAccounts(page: Int, pageSize: Int, query: String?): Result<List<AccountResponse>> {
        return networkClient.request<List<AccountResponse>>("$baseUrl/api/accounts") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (!query.isNullOrBlank()) parameter("q", query)
        }
    }

    override suspend fun getAccountById(id: String): Result<AccountResponse> {
        return networkClient.request<AccountResponse>("$baseUrl/api/accounts/$id")
    }

    override suspend fun updateAccount(request: com.clany.backoffice.model.UpdateAccountRequest): Result<AccountResponse> {
        return networkClient.request<AccountResponse>("$baseUrl/api/accounts", HttpMethod.Put, request) {
            contentType(ContentType.Application.Json)
        }
    }

    override suspend fun deleteAccount(id: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/accounts/$id", HttpMethod.Delete)
    }
}
